(function () {
  'use strict';

  var PSWP_BASE = 'https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/';
  var cssInjected = false;

  function injectCss() {
    if (cssInjected) return;
    cssInjected = true;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = PSWP_BASE + 'photoswipe.css';
    document.head.appendChild(link);
  }

  function buildPswpData(galleryId) {
    var dataEl = document.getElementById('pswp-data-' + galleryId);
    if (!dataEl) return { items: [], indexMap: {} };
    var allMedia;
    try {
      allMedia = JSON.parse(dataEl.textContent);
    } catch (e) {
      return { items: [], indexMap: {} };
    }
    var items = [];
    var indexMap = {};
    allMedia.forEach(function (media, sortedIdx) {
      if (media.type === 'image') {
        indexMap[sortedIdx] = items.length;
        items.push({ src: media.src, width: media.w, height: media.h });
      }
    });
    return { items: items, indexMap: indexMap };
  }

  function openGallery(galleryId, sortedIndex) {
    injectCss();
    var data = buildPswpData(galleryId);
    if (!data.items.length) return;
    var pswpIndex = (data.indexMap[sortedIndex] !== undefined) ? data.indexMap[sortedIndex] : 0;
    import(PSWP_BASE + 'photoswipe.esm.min.js').then(function (mod) {
      var PhotoSwipe = mod.default;
      var pswp = new PhotoSwipe({
        dataSource: data.items,
        index: pswpIndex,
        initialZoomLevel: 'fit',
        secondaryZoomLevel: 2,
        maxZoomLevel: 4,
        bgOpacity: 0.85,
        showHideAnimationType: 'fade',
      });
      pswp.init();
    });
  }

  function initGallery(gallery) {
    var galleryId = gallery.dataset.pswpGallery;
    gallery.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-pswp-open]');
      if (!trigger) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      openGallery(galleryId, parseInt(trigger.dataset.pswpOpen, 10) || 0);
    }, true);
  }

  function init() {
    document.querySelectorAll('media-gallery[data-pswp-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
